export interface ListCap {
  label: string;
  shown: number;
  total: number;
  /** False when the count request failed and the slice may be truncated. */
  totalKnown?: boolean;
}

export function hiddenListCaps(caps: ListCap[]): ListCap[] {
  return caps.filter((cap) => cap.totalKnown === false || cap.total > cap.shown);
}

export function listCapSentence(cap: ListCap): string {
  if (cap.totalKnown === false) {
    return `Showing ${cap.shown} ${cap.label}. The full count did not load, so later rows may be hidden.`;
  }
  return `Showing the first ${cap.shown} of ${cap.total} ${cap.label} — use filters for more.`;
}

export function unknownListCaps(
  shown: Record<string, number>,
  ceilings: Record<string, number>,
): ListCap[] {
  return Object.entries(ceilings)
    .filter(([label, ceiling]) => (shown[label] ?? 0) >= ceiling)
    .map(([label, ceiling]) => ({
      label,
      shown: shown[label] ?? ceiling,
      total: ceiling,
      totalKnown: false,
    }));
}
